export const countTextWidth = (text, itemPadding, fontSize) => {
  const widthOfOneChar = fontSize / 2; // approximate value
  if (!text) return 0;
  return (text.length || 0) * widthOfOneChar + itemPadding;
};
